import images from "./images";

const About = {
  sub: "About Us",
  heading: "Quality Laundry & Dry Cleaning Services",
  description: [
    "Experience top-notch laundry and dry cleaning services with us. Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum voluptatibus dolores. Experience top-notch laundry and dry cleaning services with us. Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum voluptatibus dolores."
  ],
  experience: {
    year: "20",
    text: "years of experience",
  },
  points: [
    "Expert Handling of Delicate Fabrics",
    "Budget-Friendly Dry Cleaning Solutions",
    "Stringent Quality Checks and Assurance",
    "Efficient Services with Quick Turnaround"
  ],
  image: {
    src: images.about,
    alt: "About-Image",
  },
  button: {
    text: "Learn More",
    link: "Services",
  },
};

export default About;